module.exports = __webpack_public_path__ + "img/benefit-04-camera-3.bd31e7e1.png";